interface LocalStorageData {
    key: string,
    value: string
}

export const setToLocalStorage = ({ key, value }: LocalStorageData) => {
  window.localStorage.setItem(key, value);
};

export const setToSessionStorage = ({ key, value }: LocalStorageData) => {
  window.sessionStorage.setItem(key, value);
};

export const removeFromLocalStorage = (key: string) => {
  window.localStorage.removeItem(key);
};

export const removeFromSessionStorage = (key: string) => {
  window.sessionStorage.removeItem(key);
};

export const getFromLocalStorage = (key: string) => {
  const res = window.localStorage.getItem(key);
  if (res === undefined || res === null) return '';
  try {
    return JSON.parse(res);
  } catch (error) {
    return res;
  }
};

export const getFromSessionStorage = (key: string) => {
  const res = window.sessionStorage.getItem(key);
  if (res === undefined || res === null) return '';
  try {
    return JSON.parse(res);
  } catch (error) {
    return res;
  }
};
